//EXTERNAL
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//COMPONENTS
import Article from "../components/Article";
import Header from "../components/Header";
import AdSlot from "../components/AdSlot";
//ASSETS
import PicnicLogo from "../assets/picnic-logo-white.png";
//CONFIGS
import config from "../config";

export default function Studio({ isDesktop }) {
  const location = useLocation();
  const pathname = location.pathname.split("/");
  const origin = pathname[1];
  const adSlotSize = pathname[2];
  const teamId = pathname[3];
  const creativeId = pathname[4];
  const [adSlotWidth, setAdSlotWidth] = useState(null);
  const [adSlotHeight, setAdSlotHeight] = useState(null);

  useEffect(() => {
    async function setSizes() {
      /**
       * JA (31-08-23)
       * Convert the split strings to a number value: e.g. "320" -> 320
       */
      setAdSlotWidth(+adSlotSize.split("x")[0]);
      setAdSlotHeight(+adSlotSize.split("x")[1]);
    }
    setSizes();
  }, [adSlotSize]);

  function buildFormat() {
    // ADD OTHER FORMATS HERE
    if (adSlotSize === "post") {
      return <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />;
    }
    if (adSlotSize === "story") {
      return <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />;
    }
    if (adSlotSize === "swipe") {
      return <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />;
    }
    if (adSlotSize === "carousel") {
      return <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />;
    }
    return <AdSlot path={buildPath()} id={creativeId} width={adSlotWidth} height={adSlotHeight} />;
  }

  function buildPath() {
    let studioEnv = origin === "studio" || origin === "v2" ? "production" : origin === "s" ? "staging" : "development";
    return `${config[studioEnv].studio.bucket}/${teamId}/${creativeId}/${config[studioEnv].studio.indexFile}`;
  }

  return (
    <div className="bg-pink">
      {isDesktop ? <Header Logo={PicnicLogo} /> : null}
      <Article isDesktop={isDesktop} format={buildFormat()} width={adSlotWidth} />
    </div>
  );
}
